import * as React from 'react';
import { Route, withRouter } from 'react-router-dom';
import OWAsyncRadio from '../visual_radio_input/VisualRadioInput';
import SubAssetSelectionStep from '../sub_asset_selection_step/SubAssetSelectionStep';
import { spendCategoriesRestCrudThunksForBuyer } from '../../thunks/spend_categories_thunks';
import { connect } from 'react-redux';
import { locationsRestCrudThunksForBuyer } from '../../thunks/locations_thunks';
import { problemTypesRestCrudThunksForBuyer } from '../../thunks/problem_types_thunks';
import { assetsRestReadThunk, assetsRestCrudThunksForBuyer } from '../../thunks/assets_thunks';
import { SUB_ASSETS_TARGET_COLLECTION } from '../../reducers/assets_reducer';
import { Form, Icon as LegacyIcon } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { InfoCircleOutlined, MenuOutlined } from '@ant-design/icons';
import _ from 'lodash';
import {
	Button,
	Drawer,
	Input,
	Menu,
	Modal,
	Progress,
	InputNumber,
	Popover,
	Row,
	message,
	Table,
} from 'antd';
import { getBackendUri } from '../../utils/EnvConfigUtils';
import { normFile, imageUploadValidation, imageWildcardUploadAccept } from '../../utils/ImageUtils';
import {
	getPrefilledPhotosFromImagesSearchParam,
	getProtectedImageUriForBuyer,
} from '../../utils/FileAccessUtils';
import { ROLE_TYPES, WO_STEP_NAMES } from '../../utils/DataConstants';
import {
	checkIsWarrantyWorkOrder,
	compareStrings,
	filterKeys,
	getWarrantyStatus,
	getFiltersFromLocation,
	nullSafeGet,
	nullSafeGetOrElse,
	getCurrency,
	getImageCountErrorRules,
	mergeTroubleshootingRoutes,
	getElementAt,
	isPositiveNumber,
	moveObjectToBeginning,
} from '../../utils/DataAccessUtils';
import {
	getActiveAssetWarrantySupplierId,
	getActiveBuildingWarrantySupplierId,
} from '../../utils/WarrantyUtils';
import OWRadio from '../static_visual_radio_input/StaticVisualRadioInput';
import { FormComponentProps } from '@ant-design/compatible/lib/form';
import { WORK_ORDERS_CRUD_ACTION_CREATORS } from '../../actions/work_orders_actions';
import { buyersRestCrudThunksForBuyer } from '../../thunks/buyers_thunks';
import {
	linkWorkOrderForBuyer,
	workOrdersRestCrudThunksForBuyer,
	findDuplicateWorkOrdersForBuyer,
	sendPreCreationAttributesForBuyer,
} from '../../thunks/work_orders_thunks';
import BuyerLocationUpdateForm from '../buyer_location_update_form/BuyerLocationUpdateForm';
import { buyerRoleUpdateUser } from '../../thunks/buyer_contacts_thunks';
import {
	addWarrantySupplierToStoreState,
	fetchSupplierFacilitiesInPrivateNetworkForBuyer,
	supplierFacilitiesRestCrudThunksForBuyer,
} from '../../thunks/supplier_facilities_thunks';
import { supplierPrivateNetworksV2ForBuyer } from '../../thunks/supplier_private_networks_thunks';
import SelfManagedSupplierEmailPromptModal from '../self_managed_supplier_email_prompt_modal/SelfManagedSupplierEmailPromptModal';
import {
	isSelfManagedSupplierEmailPromptEnabled,
	shouldPromptForSelfManagedSupplierEmail,
} from '../../utils/SelfManagedSupplierEmailPromptUtils';
import { workOrderAttributesRestCrudThunksForBuyer } from '../../thunks/work_order_attributes_thunks';
import { areasRestCrudThunksForBuyer, areasTopLevelForBuyer } from '../../thunks/areas_thunks';
import { retrieveCachedUserDetails } from '../../thunks/session_thunks';
import { getProposalApprovalHierarchiesByAttributes } from '../../thunks/company_approval_thunks';
import { BUYER_ADMIN_ONLY } from '../roles/roles';
import Ellipsis from 'ant-design-pro/lib/Ellipsis';
import { getBackLinkStates, getQueryStringFromObject } from '../../utils/HistoryUtils';
import { getExchangeRate } from '../../thunks/currencies_thunks';
import { troubleshootingRestCrudThunksForBuyer } from '../../thunks/troubleshooting_thunks';
import TroubleshootingDisplay from '../common/TroubleshootingDisplay';
import AssetNumberDisplay from '../asset_row_display/AssetNumberDisplay';
import { troubleshootingAnswersRestCrudThunksForBuyer } from '../../thunks/troubleshooting_answer_thunks';
import {
	buildTroubleshootingParams,
	getExistingTsAnswersFromStateForWOTsRoute,
	getTroubleshootingAnswersForNecessaryWOSteps,
	getUpdatedTroubleshootingStates,
	getUpdatedTsAnswersState,
} from '../../utils/TroubleshootingUtils';
import AccessPermissionChecker from '../common/AccessPermissionChecker';
import { PERMISSION_NAMES } from '../../utils/AuthUtils';
import OWUpload from '../OWUpload';
import {
	captureDuplicateCheckRun,
	captureDuplicateResolved,
	getAssetFilterForWOCreation,
	getFieldsSetForWorkOrderDefaults,
	getLinkedWOStateDefaults,
	getTaskListSummaryIfExist,
	getWorkOrderArchivalKey,
	getWorkOrderAttributeNTEInLocationCurrency,
	handleDuplicateCheckOnTitle,
	isWorkOrderDuplicationEnabled,
	logPreCreationAttributes,
	OPEN_WORK_ORDER_DISPLAY_STATUSES,
	onCancelRequest,
	SOURCE_SURFACES,
	WIZARD_NAMES,
} from '../../utils/WorkOrderUtils';
import { walkthroughsRestCrudThunksForBuyer } from '../../thunks/walkthroughs_thunks';
import WorkOrderSummary from '../common/WorkOrderSummary';
import WOUserLocation from './WOUserLocation';
import WOLocation from './WOLocation';
import WOProblemType from './WOProblemType';
import {
	handleProblemTypeChangeOrClick,
	PT_LEVELS,
	PT_STEP_PROPS,
} from './wo_creation_problem_type_utils';
import {
	handleLocation,
	handleLocationClick,
	LOCATION_STEP_PROPS,
} from './wo_creation_location_utils';
import WOPriority from './WOPriority';
import { workOrderPrioritiesRestCrudThunksForBuyer } from '../../thunks/work_order_priorities_thunks';
import { WorkOrderCreationDependentFieldOrder } from './wo_creation_constants';
import WOArea from './WOArea';
import { AREA_LEVELS, AREA_STEP_PROPS, handleAreaChange } from './wo_creation_area_utils';
import { workOrderSearchAndAPIAdaptor } from '../../thunks/work_orders_thunks_wrapper';
import WorkOrderTableRowWithoutActions from '../work_order_table_row_without_actions/WorkOrderTableRowWithoutActions';
import WOTaskListStep from './WOTaskListStep';
import ResolvedImage from '../resolved_image/ResolvedImage';

require('./NewWorkOrderWizardPage.less');

const duplicateWorkOrderColumns = [
	{
		title: 'Name',
		dataIndex: 'id',
		render: (text, item) => <WorkOrderTableRowWithoutActions record={item} openInNewTab />,
	},
];

interface NewWorkOrderWizardProps extends FormComponentProps {
	onSubmit: any;
	onCancel: any;
	redirectForwardUrl: any;
	saveFormData: any;
	visible: boolean;
	createErrors: any;
	updateErrors: any;
	creating: boolean;
	updating: boolean;
	location: any;
	asset: any;
	currentUser: any;
}

const DEFAULT_BACK_PATH = '/buyer/workOrders';

class NewWorkOrderWizardPage extends React.Component<any, any> {
	formRefs: any;
	linkedWOStateDefaults: any;
	initialLoadComplete: boolean;

	constructor(props) {
		super(props);
		this.formRefs = {};
		this.linkedWOStateDefaults = null;
		this.initialLoadComplete = false;

		const urlParams = new URLSearchParams(props.location.search);
		const allPhotos = getPrefilledPhotosFromImagesSearchParam(
			urlParams.get('images'),
			ROLE_TYPES.BUYER
		);
		const walkthroughId = urlParams.get('walkthroughId');
		const walkthroughTaskIndex = urlParams.get('walkthroughTaskIndex');
		const linkedWorkOrderId = urlParams.get('linkedWorkOrderId');
		const siteSurveyTaskTitleId = urlParams.get('siteSurveyTaskTitleId');
		const onlyForPreview = urlParams.get('onlyForPreview');
		this.state = {
			allPhotos: allPhotos || [],
			willChooseDates: false,
			chosenDates: [],
			willUploadPicture: false,
			area: {},
			uploadLoading: false,
			pictureURL: null,
			locations: [],
			locationUpdateVisible: false,
			userContact: {},
			previewVisible: false,
			previewImage: false,
			navMenuVisible: false,
			location: {},
			problemType: {},
			woPriority: {},
			userLocation: {},
			problemTypePriorLevelId: null,
			problemTypePriorLevel: null,
			spendCategoryId: null,
			industryId: 1,
			supplier: null,
			showingAllSuppliers: false,
			userApprovalInfo: {},
			submittedByNameIsRequired: false,
			currentRoute: '',
			assetsAvailable: false,
			hasSubAssets: false,
			selectedSubAssetIds: [],
			workOrderAttributes: null,
			backLinkParams: '',
			backLinkTo: DEFAULT_BACK_PATH,
			currencyExchangeRateLocationToSupplier: 1,
			currencyExchangeRateBuyerToLocation: 1,
			troubleshootingRoutes: [],
			troubleshootingAnswers: [],
			tsAnswerUploading: false,
			skipSupplier: false,
			numPicturesRequired: 0,
			updatingLocation: false,
			isProcessing: false,
			walkthroughId,
			walkthroughTaskIndex,
			onlyForPreview,
			linkedWorkOrderId,
			siteSurveyTaskTitleId,
			selfManagedSupplierEmailModalVisible: false,
			pendingSelfManagedSupplierEmailResolver: null,
			duplicateCheckSource: null as 'asset' | 'title' | null,
		};
	}

	maybePromptForSelfManagedSupplierEmail = (supplier) => {
		const { companyConfig, fetchSupplierRelationship } = this.props;
		if (!isSelfManagedSupplierEmailPromptEnabled(companyConfig)) {
			return Promise.resolve(supplier);
		}
		return fetchSupplierRelationship({ supplierFacilityId: nullSafeGet('id', supplier) })
			.then((relationships) => {
				const relationship = relationships && relationships.length > 0 ? relationships[0] : null;
				if (!shouldPromptForSelfManagedSupplierEmail(companyConfig, supplier, relationship)) {
					return supplier;
				}
				return new Promise((resolve) => {
					this.setState({
						selfManagedSupplierEmailModalVisible: true,
						pendingSelfManagedSupplierEmailResolver: resolve,
					});
				});
			})
			.catch(() => supplier);
	};

	handleSelfManagedSupplierEmailInvited = (values) => {
		const { pendingSelfManagedSupplierEmailResolver, supplier } = this.state;
		const updatedSupplier = {
			...(supplier || {}),
			primaryContactEmail: values.primaryContactEmail,
		};
		this.setState(
			{
				supplier: updatedSupplier,
				selfManagedSupplierEmailModalVisible: false,
				pendingSelfManagedSupplierEmailResolver: null,
			},
			() => {
				if (pendingSelfManagedSupplierEmailResolver) {
					pendingSelfManagedSupplierEmailResolver(updatedSupplier);
				}
			}
		);
	};

	handleSelfManagedSupplierEmailSkipped = () => {
		const { pendingSelfManagedSupplierEmailResolver, supplier } = this.state;
		this.setState(
			{
				selfManagedSupplierEmailModalVisible: false,
				pendingSelfManagedSupplierEmailResolver: null,
			},
			() => {
				if (pendingSelfManagedSupplierEmailResolver) {
					pendingSelfManagedSupplierEmailResolver(supplier);
				}
			}
		);
	};

	goNextAfterTaskList = () => {
		const { fetchLocationsLite, history, currentUser, form } = this.props;

		const locationId = this.state.locationId;

		if (locationId) {
			const { fetchAreasTopLevel, locations, fetchLocation, fetchExchangeRate } = this.props;

			const lProps: LOCATION_STEP_PROPS = {
				fetchAreasTopLevel,
				goNextAfterBriefPause: this.goNextAfterBriefPause,
				locations,
				TC_NAME: 'WORK_ORDER_FORM_LOCATIONS_AUTOCOMPLETE',
				fetchLocation,
				currentUser,
				fetchExchangeRate,
				setState: this.setCurrentState,
				resetFieldAFter: this.resetFieldAFter,
			};

			form.setFieldsValue({ locationId });
			handleLocation(lProps)(locationId);
		} else {
			fetchLocationsLite({}, null, { current: 1, pageSize: 2 }).then((locations) => {
				if (locations && locations.length === 1) {
					this.setState({ locations, userLocation: locations[0] });
					history.push('/buyer/workOrders/newWorkOrder/userLocation');
				} else {
					history.push('/buyer/workOrders/newWorkOrder/locations');
				}
			});
		}
	};

	componentDidMount() {
		document.body.classList.add('newWorkOrderWizardBody');
		const { fetchBuyer, currentUser, location, getApprovalHierarchy, history, form } = this.props;

		this.setState(getBackLinkStates(location, DEFAULT_BACK_PATH));

		fetchBuyer(nullSafeGet('facility.buyerCompanyId', currentUser)).then((buyer) => {
			this.setState({ industryId: buyer.industryId });
		});

		const submittedByNameIsRequired = nullSafeGetOrElse('isSharedContact', currentUser, false);
		if (submittedByNameIsRequired) {
			this.setState({ submittedByNameIsRequired: true });
		}

		const fieldsToSet = getFieldsSetForWorkOrderDefaults(location, submittedByNameIsRequired);
		form.setFieldsValue(fieldsToSet);

		if (this.state.linkedWorkOrderId) {
			this.linkedWOStateDefaults = getLinkedWOStateDefaults(fieldsToSet);
		}

		const { locationId, walkthroughId, siteSurveyTaskTitleId } = fieldsToSet;
		this.setState({ locationId }, () => {
			if (walkthroughId && siteSurveyTaskTitleId) {
				history.push(`/buyer/workOrders/newWorkOrder/${WO_STEP_NAMES.WALKTHROUGH_TASKS}`);
			} else {
				this.goNextAfterTaskList();
			}
			this.initialLoadComplete = true;
			if (this.linkedWOStateDefaults) {
				this.fetchLinkedWOEntities(fieldsToSet);
			}
		});

		getApprovalHierarchy({ isCapex: false, isPM: false, approvalHierarchyType: 'proposal' }).then(
			(result) => {
				this.setState({ currentApprovalHierarchy: result }, () =>
					this.configureNTEWarningMessage()
				);
			}
		);
	}
	configureNTEWarningMessage = () => {
		const { currentUser } = this.props;
		const { currentApprovalHierarchy } = this.state;
		const tiers = nullSafeGet('tierDetails', currentApprovalHierarchy);
		if (tiers && tiers.length > 0) {
			const userTier =
				_.find(tiers, (item) => _.find(item.approvers, { email: currentUser.email })) || tiers[0];
			this.setState({
				userApprovalInfo: { amount: userTier.amountUpto || 1000000000 },
			});
		}
	};

	toggleShowingAll() {
		this.setState({ showingAllSuppliers: !this.state.showingAllSuppliers });
	}

	componentWillUnmount() {
		document.body.classList.remove('newWorkOrderWizardBody');
		const { clearFormData } = this.props;
		clearFormData();
	}

	isProcessing = () => {
		const { creating } = this.props;
		return (
			creating ||
			this.state.isProcessing ||
			this.state.tsAnswerUploading ||
			this.state.updatingLocation
		);
	};

	setProcessing = (isProcessing) => {
		this.setState({ isProcessing });
	};

	removeTroubleshootingRoutes = (currentRoute) => {
		const routeHierarchy = [
			WO_STEP_NAMES.LOCATIONS,
			WO_STEP_NAMES.AREA_TOP_LEVEL,
			WO_STEP_NAMES.AREA_NEXT_LEVEL,
			WO_STEP_NAMES.AREA_NEXT_BRANCH,
			WO_STEP_NAMES.PROBLEM_TYPE_TOP_LEVEL,
			WO_STEP_NAMES.PROBLEM_TYPE_NEXT_LEVEL,
			WO_STEP_NAMES.PROBLEM_TYPE_NEXT_BRANCH,
			WO_STEP_NAMES.ASSET,
			WO_STEP_NAMES.ASSET_CONDITION,
			WO_STEP_NAMES.PRIORITY,
			WO_STEP_NAMES.SUPPLIER,
		];
		this.setState(getUpdatedTroubleshootingStates(routeHierarchy, currentRoute, this.state));
	};

	onRouteChanged = () => {
		const pathName = nullSafeGetOrElse('props.location.pathname', this, '');
		const currentRoute = getElementAt(pathName.split('/'), -1);
		this.removeTroubleshootingRoutes(currentRoute);
		const params = getFiltersFromLocation(this.props.location);
		const allowedStateKeys = [
			'area2Available',
			'areaPriorLevelId',
			'areaPriorLevel',
			'problemTypeLevel2Available',
			'problemTypeLevel3Available',
			'problemTypePriorLevelId',
			'problemTypePriorLevel',
			'spendCategoryId',
		];
		const newState = {
			...filterKeys(params, allowedStateKeys, true),
			currentRoute,
		};
		this.setState(newState);
	};

	getTroubleshootingParams = (previousStep) => {
		const problemTypeId =
			this.state.problemTypeLevel3Id ||
			this.state.problemTypeLevel2Id ||
			this.state.problemTypeLevel1Id;
		return buildTroubleshootingParams(
			{
				locationId: nullSafeGet('state.location.id', this),
				problemTypeId,
				assetId: nullSafeGet('state.asset.id', this),
				assetTypeId: nullSafeGet('state.asset.assetTypeId', this),
				workOrderPriorityId: nullSafeGet('state.woPriority.id', this),
				supplierFacilityId: nullSafeGet('state.supplier.facility.id', this),
			},
			previousStep
		);
	};

	checkTroubleShooting = (args, previousStep) => {
		const { fetchTroubleshooting } = this.props;
		const params = this.getTroubleshootingParams(previousStep);
		if (!Object.keys(params).length) {
			this.proceedToNextStep(args);
			return Promise.resolve();
		}
		return fetchTroubleshooting(params)
			.then((res) => {
				if (res && res.length > 0) {
					const existingTroubleshootingRoutes = nullSafeGetOrElse(
						'state.troubleshootingRoutes',
						this,
						[]
					);
					if (existingTroubleshootingRoutes.find((_) => _.id === res[0].id)) {
						this.proceedToNextStep(args);
					} else {
						this.setState({
							troubleshootingRoutes: [
								...existingTroubleshootingRoutes,
								...[
									{
										...res[0],
										args,
										previousStep,
									},
								],
							],
						});
						this.proceedToNextStep({
							validationSteps: [],
							destination: `troubleshooting-${res[0].id}`,
						});
					}
				} else {
					this.proceedToNextStep(args);
				}
			})
			.catch(() => {
				this.setProcessing(false);
			});
	};

	componentDidUpdate(prevProps): void {
		if (this.props.location !== prevProps.location) {
			this.onRouteChanged();
		}
	}

	updateTroubleshootingAnswerIfAvailable = (workOrder) => {
		const { createTroubleshootingAnswersBulk } = this.props;
		const answers = nullSafeGetOrElse('troubleshootingAnswers', this.state, []);
		return new Promise((resolve, reject) => {
			if (answers.length > 0) {
				this.setState({ tsAnswerUploading: true });
				createTroubleshootingAnswersBulk(
					answers.map((_) => ({
						..._,
						workOrderId: workOrder.id,
					}))
				)
					.then((res) => {
						resolve(res);
					})
					.catch((err) => {
						message.error(err);
						reject(err);
					})
					.finally(() => this.setState({ tsAnswerUploading: false }));
			} else {
				resolve(true);
			}
		});
	};

	updateLinkingIfAvailable = (newWorkOrder) => {
		return new Promise((resolve, reject) => {
			const { linkWorkOrders } = this.props;
			if (this.state.linkedWorkOrderId) {
				return linkWorkOrders(this.state.linkedWorkOrderId, [newWorkOrder.id], true).then(() => {
					resolve(true);
				});
			} else {
				resolve(true);
			}
		});
	};

	handleSubmit = () => {
		const { form, formData, history, currentUser, submitWorkOrderForm, deleteWorkOrderFromRedux } =
			this.props;
		const { location, currencyExchangeRateLocationToSupplier, supplier } = this.state;
		// Guard against double-submit: a rapid second click would otherwise slip through the
		// async form.validateFields window and create a duplicate work order (OPE-4890).
		if (this.isProcessing()) {
			return;
		}
		this.setState({ isProcessing: true });
		form.validateFields((err, values) => {
			if (err) {
				this.setState({ isProcessing: false });
				return;
			}
			{
				// put image data into proper format to persist
				const picturesInfo = this.state.allPhotos.map((p) => {
					const fileName = nullSafeGetOrElse('response.data.fileName', p, '');
					const fileId = nullSafeGetOrElse('response.data.fileId', p, '');
					return `${fileId}/${fileName}`;
				});

				const contractorDetails = {
					contractorContacts: [],
				};
				const locationCurrencyId = getCurrency({ location }).id;
				const supplierCurrencyId = getCurrency({ supplier }).id;

				const DEFAULT_SPEND_CATEGORY = '17';

				const workOrder = {
					title: values.title,
					woPriorityId: nullSafeGet('id', this.state.woPriority)
						? parseInt(nullSafeGet('id', this.state.woPriority), 10)
						: null,
					problemTypeId: nullSafeGet('id', this.state.problemType)
						? parseInt(nullSafeGet('id', this.state.problemType), 10)
						: null,
					spendCategoryId: parseInt(
						nullSafeGetOrElse('spendCategoryId', this.state, DEFAULT_SPEND_CATEGORY),
						10
					),
					locationId: parseInt(nullSafeGet('location.id', this.state), 10),
					areaId: nullSafeGet('id', this.state.area)
						? parseInt(nullSafeGet('id', this.state.area), 10)
						: null,
					assetId: formData.assetId ? parseInt(formData.assetId, 10) : null,
					...(formData.assetId && {
						isAssetDown: formData.isAssetDown === 'true' ? true : false,
					}),
					// Only include subAssetIds when the picker would have been visible — i.e.
					// an asset is selected AND the loaded asset has sub-assets.
					...(formData.assetId && nullSafeGetOrElse('subAssetCount', this.state.asset, 0) > 0
						? {
								subAssetIds:
									this.state.selectedSubAssetIds.length > 0 ? this.state.selectedSubAssetIds : null,
						  }
						: {}),
					images: picturesInfo,
					currencyExchangeRateLocationToSupplier: currencyExchangeRateLocationToSupplier,
					nte: this.state.nte ? this.state.nte * currencyExchangeRateLocationToSupplier : undefined,
					currencyId: supplierCurrencyId,
					nteInLocationCurrency: formData.nte ? parseFloat(formData.nte) : undefined,
					locationCurrencyId: locationCurrencyId,
					description: formData.additionalInfo,
					buyerFacilityId: nullSafeGet('buyerFacilityId', location),
					buyerCompanyId: values.buyerCompanyId,
					createdBy: currentUser.email,
					supplierFacilityId: nullSafeGet('id', this.state.supplier)
						? parseInt(nullSafeGet('id', this.state.supplier), 10)
						: null,
					contractorDetails: contractorDetails,
					submittedByName: formData.submittedByName,
					notes: [],
					buyerAttachments: formData.buyerAttachments,
					isWarranty: checkIsWarrantyWorkOrder(
						nullSafeGet('asset.warranties.0', this.state),
						nullSafeGet('id', this.state.supplier)
					),
					skipSupplier: this.state.skipSupplier,
					walkThroughId: this.state.walkthroughId ? parseInt(this.state.walkthroughId) : undefined,
					siteSurveyTaskTitleId: this.state.siteSurveyTaskTitleId
						? this.state.siteSurveyTaskTitleId
						: undefined,
					includeWalkthroughTaskList: this.state.includeWalkthroughTaskList,
				};

				submitWorkOrderForm(workOrder)
					.then((rec) => {
						logPreCreationAttributes({
							state: this.state,
							currentUser: this.props.currentUser,
							sendPreCreationAttributesFn: sendPreCreationAttributesForBuyer,
							source: SOURCE_SURFACES.STANDARD,
							createdWorkOrderId: parseInt(rec.id, 10),
						});
						const promises = [
							this.updateTroubleshootingAnswerIfAvailable(rec),
							this.updateLinkingIfAvailable(rec),
						];
						deleteWorkOrderFromRedux(rec);
						return Promise.all(promises).then(() => {
							if (this.state.walkthroughId) {
								history.push(
									`/buyer/siteSurveys/walkthrough/detail/${this.state.walkthroughId}/details`
								);
							} else if (this.state.linkedWorkOrderId) {
								history.push(
									`/buyer/workOrders/detail/${this.state.linkedWorkOrderId}/linked`.concat(
										'?',
										this.state.backLinkParams
									)
								);
							} else {
								history.push(
									`/buyer/workOrders/detail/${rec.id}`.concat('?', this.state.backLinkParams)
								);
							}
						});
					})
					.catch(() => {
						this.setState({ isProcessing: false });
					});
			}
		});
	};

	handleUploadPicture = (value) => {
		value.target.value === 'yes'
			? this.setState({
					willUploadPicture: true,
			  })
			: this.setState({
					willUploadPicture: false,
			  });
	};

	provideLocationAccess = (record) => {
		const { locations } = this.state;
		this.setState({
			locationUpdateVisible: true,
			userContact: {
				contact: {
					...record,
				},
				role: record['roles'],
				locationIds: locations.map((l) => l.id),
			},
		});
	};

	proceedToNextStep = (values) => {
		const { validationSteps, destination, useReplace = false, params = {} } = values;
		const { form, history } = this.props;
		return new Promise<void>((resolve, reject) => {
			form.validateFields(validationSteps, (err) => {
				if (err) {
					console.log(err);
					this.setProcessing(false);
					reject(err);
					return;
				}
				window.scrollTo(0, 0);
				const navigateFunction = useReplace ? history.replace : history.push;
				const queryString = getQueryStringFromObject(params);
				const navigateTo = `/buyer/workOrders/newWorkOrder/${destination}${
					queryString ? `?${queryString}` : ''
				}`;
				navigateFunction(navigateTo);
				this.setProcessing(false);
				resolve();
			});
		});
	};

	goNext = (
		validationSteps,
		destination,
		stepName,
		ingnoreTroubleshooting = false,
		useReplace = false,
		params = {}
	) => {
		this.setProcessing(true);
		const args = {
			validationSteps,
			destination,
			useReplace,
			params,
		};

		const requiredSteps = [
			WO_STEP_NAMES.LOCATIONS,
			WO_STEP_NAMES.PROBLEM_TYPE_TOP_LEVEL,
			WO_STEP_NAMES.PROBLEM_TYPE_NEXT_LEVEL,
			WO_STEP_NAMES.PROBLEM_TYPE_NEXT_BRANCH,
			WO_STEP_NAMES.ASSET,
			WO_STEP_NAMES.PRIORITY,
			WO_STEP_NAMES.SUPPLIER,
		];

		if (!ingnoreTroubleshooting && requiredSteps.includes(stepName)) {
			return this.checkTroubleShooting(args, stepName);
		} else {
			return this.proceedToNextStep(args);
		}
	};

	cancelRequest = () => this.props.history.push(this.state.backLinkTo);

	goBack = () => {
		const { history } = this.props;
		history.goBack();
	};

	goNextAfterBriefPause = (
		validationSteps,
		destination,
		currentStep,
		ignoreTroubleshooting = false
	) => {
		this.setProcessing(true);
		setTimeout(
			() => this.goNext(validationSteps, destination, currentStep, ignoreTroubleshooting),
			350
		);
	};

	resetFieldAFter = (changedState) => {
		if (changedState === 'locations' && this.linkedWOStateDefaults) {
			const currentLocationId = nullSafeGet('location.id', this.state);
			const newLocationId = this.props.form.getFieldValue('locationId');
			if (currentLocationId && !compareStrings(currentLocationId, newLocationId)) {
				this.linkedWOStateDefaults = null;
			}
		}

		const index = WorkOrderCreationDependentFieldOrder.findIndex((_) => _.key === changedState);
		const newState =
			index > -1
				? WorkOrderCreationDependentFieldOrder.slice(index + 1).reduce((obj, field) => {
						obj[field.key] = field.default;
						return obj;
				  }, {})
				: {};

		if (this.linkedWOStateDefaults) {
			Object.keys(newState).forEach((key) => {
				if (this.linkedWOStateDefaults[key] !== undefined) {
					newState[key] = this.linkedWOStateDefaults[key];
				}
			});
		}

		this.setState(newState);
	};

	changeId = (key, value) => {
		this.setState({ [key]: value });

		if (
			this.linkedWOStateDefaults &&
			this.linkedWOStateDefaults[key] !== undefined &&
			!compareStrings(value, this.linkedWOStateDefaults[key])
		) {
			const index = WorkOrderCreationDependentFieldOrder.findIndex((_) => _.key === key);
			if (index > -1) {
				WorkOrderCreationDependentFieldOrder.slice(index + 1).forEach((field) => {
					delete this.linkedWOStateDefaults[field.key];
				});
			}
		}

		this.resetFieldAFter(key);
	};

	fetchLinkedWOEntities = (fieldsToSet) => {
		const { fetchArea, fetchProblemType, form } = this.props;
		const promises = [];

		const deepestAreaId =
			fieldsToSet.areaIdNextLevel || fieldsToSet.areaId || fieldsToSet.areasTopLevel;
		const deepestProblemTypeId =
			fieldsToSet.problemTypeIdNextLevel ||
			fieldsToSet.problemTypeId ||
			fieldsToSet.problemTypeTopLevel;

		if (deepestAreaId) {
			promises.push(fetchArea(deepestAreaId));
		}
		if (deepestProblemTypeId) {
			promises.push(fetchProblemType(deepestProblemTypeId));
		}

		if (promises.length > 0) {
			Promise.all(promises)
				.then((results) => {
					// If linkedWOStateDefaults was nullified (e.g. user changed location),
					// discard stale linked WO data to avoid inconsistent state.
					if (!this.linkedWOStateDefaults) {
						return;
					}

					const stateUpdate: any = {};
					let resultIndex = 0;

					if (deepestAreaId) {
						stateUpdate.area = results[resultIndex];
						resultIndex++;
					}
					if (deepestProblemTypeId) {
						stateUpdate.problemType = results[resultIndex];
					}

					this.setState(stateUpdate);

					if (fieldsToSet.areasTopLevel) {
						form.setFieldsValue({ areasTopLevel: fieldsToSet.areasTopLevel });
					}
					if (fieldsToSet.areaId) {
						form.setFieldsValue({ areaId: fieldsToSet.areaId });
					}
					if (fieldsToSet.areaIdNextLevel) {
						form.setFieldsValue({ areaIdNextLevel: fieldsToSet.areaIdNextLevel });
					}
					if (fieldsToSet.problemTypeTopLevel) {
						form.setFieldsValue({ problemTypeTopLevel: fieldsToSet.problemTypeTopLevel });
					}
					if (fieldsToSet.problemTypeId) {
						form.setFieldsValue({ problemTypeId: fieldsToSet.problemTypeId });
					}
					if (fieldsToSet.problemTypeIdNextLevel) {
						form.setFieldsValue({ problemTypeIdNextLevel: fieldsToSet.problemTypeIdNextLevel });
					}
				})
				.catch(() => {});
		}
	};

	saveFormRef = (formName) => (formRef) => {
		this.formRefs[formName] = formRef;
	};

	handleBuyerLocationUpdateCancel = () => {
		this.setState({
			locationUpdateVisible: false,
		});
	};

	handleBuyerLocationUpdateSubmit = () => {
		const { roleUpdateUser } = this.props;
		const form = this.formRefs['locationUpdateForm'].props.form;
		this.setState({ updatingLocation: true });
		form.validateFields((err, values) => {
			if (err) {
				this.setState({ updatingLocation: false });
				return;
			}

			const updateRole = {
				userId: values.email,
				roles: [values.roles],
				locationIds: values.locationIds,
			};

			roleUpdateUser(updateRole)
				.then(() => {
					this.setState({ locationUpdateVisible: false });
					this.goNext([], 'locations', '');
				})
				.catch((err) => {
					message.error(err);
					this.setState({ updatingLocation: false });
				});
		});
	};

	handlePreview = (obj) => {
		let thumbUrl = null;
		let fullUrl = null;
		let photoInfo = null;
		if (obj.response.data) {
			const imgFileId = obj.response.data.fileId;
			const imgFileName = obj.response.data.fileName;
			thumbUrl = getProtectedImageUriForBuyer(imgFileId, imgFileName, 100, 100);
			fullUrl = getProtectedImageUriForBuyer(imgFileId, imgFileName, 800, 800);
			photoInfo = {
				uid: imgFileId,
				size: 1,
				name: imgFileName,
				filename: imgFileName,
				url: fullUrl,
				status: 'done',
				thumbUrl: thumbUrl,
				response: { data: { fileName: imgFileName, fileId: imgFileId } },
				type: 'image',
			};
		}
		this.setState({
			photoInfo: [photoInfo],
			previewImage: fullUrl || thumbUrl,
			previewVisible: true,
		});
	};

	handleDuplicate = (resp) => {
		captureDuplicateResolved({
			wizard: WIZARD_NAMES.BUYER_NEW_WORK_ORDER,
			source: this.state.duplicateCheckSource,
			resp,
			shownCount: nullSafeGetOrElse('duplicateWorkOrders.length', this.state, 0),
		});
		if (resp == 1) {
			this.props.history.push('/buyer/workOrders');
			logPreCreationAttributes({
				state: this.state,
				currentUser: this.props.currentUser,
				sendPreCreationAttributesFn: sendPreCreationAttributesForBuyer,
				source: SOURCE_SURFACES.STANDARD,
				duplicateWorkOrderId: parseInt(nullSafeGet('duplicateWorkOrders.0.id', this.state), 10),
			});
		} else {
			const destination =
				this.state.duplicateCheckSource === 'title' ? 'photos' : this.nextAfterAsset();
			this.goNextAfterBriefPause([], destination, WO_STEP_NAMES.DUPLICATE_CHECK);
		}
	};

	handleTitle = () =>
		handleDuplicateCheckOnTitle({
			state: this.state,
			form: this.props.form,
			currentUser: this.props.currentUser,
			findDuplicateWorkOrders: this.props.findDuplicateWorkOrders,
			setState: (state) => this.setState(state),
			setProcessing: this.setProcessing,
			goNext: this.goNext,
			goNextAfterBriefPause: this.goNextAfterBriefPause,
			wizard: WIZARD_NAMES.BUYER_NEW_WORK_ORDER,
		});

	handleImageUpdate = (info) => {
		this.setState({ allPhotos: info.fileList.filter((img) => img.status === 'done') });
	};

	handleUserLocation = (resp) => {
		const { userLocation } = this.state;
		const { form, currentUser, saveFormData } = this.props;
		if (resp == 1) {
			form.setFieldsValue({ locationId: userLocation.id });
			saveFormData({ locationId: userLocation.id });

			const { fetchAreasTopLevel, locations, fetchLocation, fetchExchangeRate } = this.props;

			const lProps: LOCATION_STEP_PROPS = {
				fetchAreasTopLevel,
				goNextAfterBriefPause: this.goNextAfterBriefPause,
				locations,
				TC_NAME: 'WORK_ORDER_FORM_LOCATIONS_AUTOCOMPLETE',
				fetchLocation,
				currentUser,
				fetchExchangeRate,
				setState: this.setCurrentState,
				resetFieldAFter: this.resetFieldAFter,
			};

			handleLocation(lProps)(userLocation.id);
		} else {
			this.provideLocationAccess(currentUser);
		}
	};

	handleBuyerCurrencyToLocationExchangeRate = (location) => {
		const { fetchExchangeRate, currentUser } = this.props;
		const locationCurrencyId = getCurrency({ location }).id;
		const buyerCurrencyId = getCurrency({ currentUser }).id;
		if (locationCurrencyId !== buyerCurrencyId) {
			fetchExchangeRate(locationCurrencyId, buyerCurrencyId, currentUser.contactType).then(
				(rate) => {
					this.setState({
						currencyExchangeRateBuyerToLocation: nullSafeGetOrElse('conversionRate', rate, 1),
					});
				}
			);
		} else {
			this.setState({ currencyExchangeRateBuyerToLocation: 1 });
		}
	};

	setCurrentState = (st, callBack?) => this.setState(st, callBack);

	getCurrentState = () => this.state;

	checkForSharedContactAndMoveToNextStep = (validation, currentStep) => {
		const { currentUser } = this.props;
		nullSafeGetOrElse('isSharedContact', currentUser, false)
			? this.goNextAfterBriefPause(validation, WO_STEP_NAMES.SUBMITTED_BY, currentStep)
			: this.goNextAfterBriefPause(validation, WO_STEP_NAMES.COMPLETION, currentStep);
	};

	setNTE = (nte) => {
		const { form } = this.props;
		this.setState({ nte });
		form.setFieldsValue({
			nte: isPositiveNumber(nte) ? parseFloat(nte).toFixed(2) : 0,
		});
	};

	setDefaultNTE = (supplierFacilityId) => {
		const { form } = this.props;
		const {
			workOrderAttributes = [],
			asset,
			supplier = {},
			currencyExchangeRateBuyerToLocation,
		} = this.state;
		if (
			checkIsWarrantyWorkOrder(nullSafeGet('warranties.0', asset), parseInt(supplierFacilityId)) &&
			nullSafeGet('warranties.0.NTEAmount', asset)
		) {
			this.setNTE(
				nullSafeGet('warranties.0.NTEAmount', asset) * currencyExchangeRateBuyerToLocation
			);
		} else if (supplier.status === 'private') {
			this.setNTE(null);
		} else {
			if (nullSafeGetOrElse('length', workOrderAttributes, 0) > 0) {
				if (workOrderAttributes[0].NTEAmount) {
					const { fetchExchangeRate, currentUser } = this.props;
					getWorkOrderAttributeNTEInLocationCurrency(
						workOrderAttributes[0],
						this.state.location,
						fetchExchangeRate,
						nullSafeGet('contactType', currentUser)
					).then((nte) => this.setNTE(nte));
				}
			}
		}
	};

	handleNTESubmit = () => {
		const { formData } = this.props;
		this.setNTE(formData.nte);
	};

	handleSupplierChange = (facilityId?: any) => {
		const { fetchSupplierFacility, fetchExchangeRate, currentUser } = this.props;
		const { location, supplier = {} } = this.state;
		!!facilityId && this.setState({ skipSupplier: false });
		const supplierFacilityId = facilityId || nullSafeGet('id', supplier);
		if (supplierFacilityId) {
			this.setProcessing(true);
			fetchSupplierFacility(supplierFacilityId)
				.then((supplier) => {
					this.setState(
						{
							supplier,
						},
						() => {
							this.maybePromptForSelfManagedSupplierEmail(supplier).then((effectiveSupplier) => {
								if (!effectiveSupplier) {
									this.setProcessing(false);
									return;
								}
								const locationCurrencyId = getCurrency({ location }).id;
								const supplierCurrencyId = getCurrency({ supplier: effectiveSupplier }).id;
								if (locationCurrencyId !== supplierCurrencyId) {
									fetchExchangeRate(supplierCurrencyId, locationCurrencyId, currentUser.contactType)
										.then((rate) => {
											this.setState({
												currencyExchangeRateLocationToSupplier: nullSafeGetOrElse(
													'conversionRate',
													rate,
													1
												),
											});
											this.setDefaultNTE(supplierFacilityId);
											if (effectiveSupplier.status === 'private') {
												this.setNTE(undefined);
												this.checkForSharedContactAndMoveToNextStep([], WO_STEP_NAMES.SUPPLIER);
											} else {
												this.goNextAfterBriefPause([], WO_STEP_NAMES.NTE, WO_STEP_NAMES.SUPPLIER);
											}
										})
										.catch(() => {
											this.setProcessing(false);
										});
								} else {
									this.setState({ currencyExchangeRateLocationToSupplier: 1 });
									this.setDefaultNTE(supplierFacilityId);
									if (effectiveSupplier.status === 'private') {
										this.setNTE(undefined);
										this.checkForSharedContactAndMoveToNextStep([], WO_STEP_NAMES.SUPPLIER);
									} else {
										this.goNextAfterBriefPause([], WO_STEP_NAMES.NTE, WO_STEP_NAMES.SUPPLIER);
									}
								}
							});
						}
					);
				})
				.catch(() => {
					this.setProcessing(false);
				});
		} else {
			this.setProcessing(true);
			this.goNextAfterBriefPause([], WO_STEP_NAMES.NTE, WO_STEP_NAMES.SUPPLIER);
		}
	};

	handleAsset = (assetId) => {
		const {
			fetchAsset,
			fetchSupplierFacilitiesInPrivateNetwork,
			form,
			fetchWorkOrders,
			history,
			currentUser,
		} = this.props;
		const { currencyExchangeRateBuyerToLocation } = this.state;
		const { getFieldValue } = form;

		const isAssetKnown = getFieldValue('isAssetKnown');
		if (isAssetKnown === 'true') {
			history.push(
				`/buyer/assets/${assetId}/newWorkOrder?areaId=${nullSafeGet('id', this.state.area)}`
			);
			return;
		}
		this.setProcessing(true);
		fetchAsset(assetId)
			.then((asset) => {
				return fetchSupplierFacilitiesInPrivateNetwork({
					problemTypeId: nullSafeGet('problemType.id', this.state),
					locationId: nullSafeGet('id', this.state.location),
				}).then((s) => {
					const assetWarrantyStatus = getWarrantyStatus(nullSafeGet('warranties.0', asset));
					const assetSupplier = nullSafeGet('warranties.0.provider.supplierFacility', asset);
					const assetWarrantyNTE = nullSafeGet('warranties.0.NTEAmount', asset);
					if (assetWarrantyStatus === 'Active' && assetWarrantyNTE) {
						this.setNTE(assetWarrantyNTE * currencyExchangeRateBuyerToLocation);
					}
					const hasSubAssets = nullSafeGetOrElse('subAssetCount', asset, 0) > 0;
					this.setState(
						{
							asset,
							hasSubAssets,
							selectedSubAssetIds: [],
							supplier:
								assetWarrantyStatus === 'Active' && assetSupplier
									? assetSupplier
									: this.state.supplier,
						},
						() => {
							if (isWorkOrderDuplicationEnabled()) {
								this.goNext([], this.nextAfterAsset(), WO_STEP_NAMES.ASSET);
								return;
							}
							fetchWorkOrders({
								assetId,
								locationId: nullSafeGet('location.id', this.state),
								isPM: false,
								displayStatuses: OPEN_WORK_ORDER_DISPLAY_STATUSES,
								[getWorkOrderArchivalKey(currentUser)]: false,
							})
								.then((workOrders) => {
									captureDuplicateCheckRun({
										wizard: WIZARD_NAMES.BUYER_NEW_WORK_ORDER,
										source: 'asset',
										rawWorkOrders: workOrders,
										shownWorkOrders: workOrders,
										context: {
											locationId: nullSafeGet('location.id', this.state),
											assetId,
										},
									});
									if (!workOrders || workOrders.length === 0) {
										this.goNext([], this.nextAfterAsset(), WO_STEP_NAMES.ASSET);
									} else {
										this.setState({
											duplicateWorkOrders: workOrders,
											duplicateCheckSource: 'asset',
										});
										this.goNext([], WO_STEP_NAMES.DUPLICATE_CHECK, WO_STEP_NAMES.ASSET);
									}
								})
								.catch(() => {
									this.setProcessing(false);
								});
						}
					);
				});
			})
			.catch(() => {
				this.setProcessing(false);
			});
	};

	handleAssetClick = () => {
		this.goNext([], this.nextAfterAsset(), WO_STEP_NAMES.ASSET);
	};

	// After the asset step, route to the sub-asset picker only when the chosen
	// asset is a parent (subAssetCount > 0); otherwise continue to asset condition.
	nextAfterAsset = () =>
		this.state.hasSubAssets ? WO_STEP_NAMES.SUB_ASSET : WO_STEP_NAMES.ASSET_CONDITION;

	handleAssetCondition = () => {
		this.goNextAfterBriefPause([], WO_STEP_NAMES.TITLE, WO_STEP_NAMES.ASSET_CONDITION);
	};

	handleAssetCheck = (value) => {
		if (value === 'true') {
			this.goNext([], WO_STEP_NAMES.ASSET, WO_STEP_NAMES.AREA_TOP_LEVEL, false);
		} else {
			this.goNext([], WO_STEP_NAMES.PROBLEM_TYPE_TOP_LEVEL, WO_STEP_NAMES.AREA_TOP_LEVEL, false);
		}
	};

	handleNavMenuClose = () => {
		this.setState({ navMenuVisible: false });
	};

	handleNavMenuOpen = () => {
		this.setState({ navMenuVisible: true });
	};

	handleNavMenuClick = (e) => {
		const {
			fetchAssets,
			companyConfig,
			currentUser,
			problemTypes,
			fetchProblemType,
			fetchSupplierFacilitiesInPrivateNetwork,
			fetchWorkOrderAttributes,
			fetchAreasTopLevel,
			locations,
			fetchLocation,
			fetchExchangeRate,
			fetchWorkOrderPriority,
			areas,
			fetchArea,
		} = this.props;

		const ptProps: PT_STEP_PROPS = {
			fetchAssets,
			goNext: this.goNext,
			setState: this.setCurrentState,
			companyConfig,
			currentUser,
			getCurrentState: this.getCurrentState,
			problemTypes,
			TC_NAME: 'WORK_ORDER_PROBLEM_TYPES_TOP_LEVEL_AUTOCOMPLETE',
			fetchProblemType,
			fetchSupplierFacilitiesInPrivateNetwork,
			fetchSupplierFacility: this.props.fetchSupplierFacility,
			fetchWorkOrderAttributes,
			setNTE: this.setNTE,
			changeId: this.changeId,
			fetchWorkOrderPriority,
			form: this.props.form,
		};

		const lProps: LOCATION_STEP_PROPS = {
			fetchAreasTopLevel,
			goNextAfterBriefPause: this.goNextAfterBriefPause,
			locations,
			TC_NAME: 'WORK_ORDER_FORM_LOCATIONS_AUTOCOMPLETE',
			fetchLocation,
			currentUser,
			fetchExchangeRate,
			setState: this.setCurrentState,
			resetFieldAFter: this.resetFieldAFter,
		};

		const aProps: AREA_STEP_PROPS = {
			goNext: this.goNext,
			setState: this.setCurrentState,
			getCurrentState: this.getCurrentState,
			areas,
			TC_NAME: 'WORK_ORDER_FORM_AREAS_AUTOCOMPLETE',
			fetchArea,
			changeId: this.changeId,
		};

		const methods = {
			areasTopLevel: () =>
				handleLocationClick(lProps)(nullSafeGet('location.id', this.state), true),
			areasNextLevel: () =>
				handleAreaChange(aProps)(AREA_LEVELS.TOP_LEVEL, this.state.areaLevel1Id, true),
			areasNextBranch: () =>
				handleAreaChange(aProps)(AREA_LEVELS.NEXT_LEVEL, this.state.areaLevel2Id, true),
			problemTypeNextLevel: () =>
				handleProblemTypeChangeOrClick(ptProps)(
					PT_LEVELS.TOP_LEVEL,
					this.state.problemTypeLevel1Id,
					true
				),
			problemTypeNextBranch: () =>
				handleProblemTypeChangeOrClick(ptProps)(
					PT_LEVELS.NEXT_LEVEL,
					this.state.problemTypeLevel2Id,
					true
				),
		};
		methods[e.key] ? methods[e.key]() : this.goNext([], e.key, '', true);
	};

	handleCancel = () => this.setState({ previewVisible: false });

	isTroubleshootingAllowedToProceed = (checkSteps) => {
		const tsRoutes = nullSafeGetOrElse('state.troubleshootingRoutes', this, []);
		const allowedToProceed =
			tsRoutes
				.filter((_) => checkSteps.includes(_.previousStep))
				.filter((_) => !nullSafeGetOrElse('troubleshootingSteps', _, [{}])[0].canProceedToNextStep)
				.length === 0;

		return allowedToProceed;
	};

	isLocationFieldsSelected = () => {
		const {
			userLocation,
			location,
			areas,
			areaLevel1Id,
			area2Available,
			area3Available,
			areaLevel2Id,
			areaLevel3Id,
		} = this.state;
		const locationFieldSelected =
			userLocation.id || location.id
				? areas && areas.length > 0
					? areaLevel1Id
						? area2Available
							? areaLevel2Id
								? area3Available
									? areaLevel3Id
										? true
										: false
									: true
								: false
							: true
						: false
					: true
				: false;

		const checkSteps = [WO_STEP_NAMES.LOCATIONS];

		return locationFieldSelected && this.isTroubleshootingAllowedToProceed(checkSteps);
	};

	isProblemTypeAndAssetSelected = () => {
		const {
			problemTypeLevel1Id,
			problemTypeLevel2Available,
			problemTypeLevel2Id,
			problemTypeLevel3Available,
			problemTypeLevel3Id,
		} = this.state;
		const problemTypeSelected = problemTypeLevel1Id
			? problemTypeLevel2Available
				? problemTypeLevel2Id
					? problemTypeLevel3Available
						? problemTypeLevel3Id
							? true
							: false
						: true
					: false
				: true
			: false;

		const checkSteps = [
			WO_STEP_NAMES.PROBLEM_TYPE_TOP_LEVEL,
			WO_STEP_NAMES.PROBLEM_TYPE_NEXT_LEVEL,
			WO_STEP_NAMES.PROBLEM_TYPE_NEXT_BRANCH,
		];
		return problemTypeSelected && this.isTroubleshootingAllowedToProceed(checkSteps);
	};

	isPrioritySelected = () =>
		nullSafeGet('woPriority.id', this.state) &&
		this.isTroubleshootingAllowedToProceed([WO_STEP_NAMES.PRIORITY]);

	render() {
		const {
			companyConfig,
			location,
			areas,
			fetchAreas,
			fetchMultipleAreas,
			assets,
			fetchAssets,
			fetchMultipleAssets,
			creating,
			formData,
			supplierFacilities,
			fetchSupplierFacilitiesInPrivateNetwork,
			fetchMultipleSupplierFacilities,
			form,
			currentUser,
			addWarrantySupplier,
		} = this.props;
		const { getFieldDecorator, getFieldValue } = form;
		const {
			previewVisible,
			previewImage,
			showingAllSuppliers,
			currencyExchangeRateBuyerToLocation,
			nte,
		} = this.state;
		const BACKEND_URI = getBackendUri();
		const uploadHeaders = { 'X-Auth-Token': retrieveCachedUserDetails(['token']).token };
		const isAdmin = currentUser.roles.some((role) => BUYER_ADMIN_ONLY.has(role));
		const { userApprovalInfo, currencyExchangeRateLocationToSupplier } = this.state;
		const locationCurrency = getCurrency({ location: this.state.location });
		const supplierCurrency = getCurrency({ supplier: this.state.supplier });
		const workOrderCurrency = getCurrency({
			supplier: this.state.supplier,
			location: this.state.location,
		});
		const isSameCurrency = locationCurrency.id === supplierCurrency.id;
		const isProcessing = this.isProcessing();

		const { locationTsAnswer, problemTypeTsAnswer, priorityTsAnswer } =
			getTroubleshootingAnswersForNecessaryWOSteps(this.state);

		const workOrderDetails = [
			{ key: 'Location', value: nullSafeGetOrElse('name', this.state.location, '') },
			...locationTsAnswer,
			{ key: 'Area', value: nullSafeGetOrElse('hierarchyName', this.state.area, '') },
			{
				key: 'Problem Type',
				value: nullSafeGetOrElse('hierarchyName', this.state.problemType, ''),
			},
			...problemTypeTsAnswer,
			{ key: 'Asset', value: nullSafeGetOrElse('name', this.state.asset, '') },
			{
				key: 'Sub Assets',
				value: this.state.selectedSubAssetIds
					.map((id) => nullSafeGet(`records.${id}.name`, assets))
					.filter(Boolean)
					.join(', '),
			},
			...(nullSafeGetOrElse('name', this.state.asset, '')
				? [
						{
							key: 'Is the Asset Under Warranty?',
							value: checkIsWarrantyWorkOrder(
								nullSafeGet('asset.warranties.0', this.state),
								nullSafeGet('id', this.state.supplier)
							)
								? 'Yes'
								: 'No',
						},
						{
							key: 'Is the Asset functioning?',
							value: formData.isAssetDown === 'true' ? 'No' : 'Yes',
						},
				  ]
				: []),
			{ key: 'Title', value: nullSafeGetOrElse('title', formData, '') },
			{ key: 'Priority', value: nullSafeGetOrElse('woPriority.name', this.state, '') },
			...priorityTsAnswer,
			{ key: 'Submitted By', value: nullSafeGetOrElse('submittedByName', formData, '') },
			{ key: 'Service Provider', value: nullSafeGetOrElse('supplier.name', this.state, '') },
			...(isPositiveNumber(nte)
				? [
						{
							key: 'NTE',
							value: workOrderCurrency.format(
								this.state.nte * currencyExchangeRateLocationToSupplier
							),
						},
				  ]
				: []),
			...getTaskListSummaryIfExist(this.state),
		];

		const photoStrings = (getFieldValue('images') || []).map((p) => {
			const fileName = nullSafeGetOrElse('response.data.fileName', p, '');
			const fileId = nullSafeGetOrElse('response.data.fileId', p, '');
			return `${fileId}/${fileName}`;
		});

		const isImageUploading = (getFieldValue('images') || []).some((_) => _.status === 'uploading');

		const minPhotosCount = nullSafeGetOrElse('state.numPicturesRequired', this, 0);

		const imageCountErrorMessage = `You need to upload at least ${minPhotosCount} photo${
			minPhotosCount > 1 ? 's' : ''
		}`;

		const imageCountMatched =
			minPhotosCount <= nullSafeGetOrElse('length', getFieldValue('images'), 0);

		const getTroubleshootingSteps = () => {
			const troubleshootingRoutes = nullSafeGetOrElse('state.troubleshootingRoutes', this, []);
			return troubleshootingRoutes.reduce((steps, route) => {
				const existingAnswer = getExistingTsAnswersFromStateForWOTsRoute(this.state, route);
				return {
					...steps,
					[`troubleshooting-${route.id}`]: {
						id: `t-${route.id}`,
						label: 'Troubleshooting',
						component: (
							<TroubleshootingDisplay
								troubleshootingSteps={route.troubleshootingSteps}
								onBack={this.goBack}
								onNextStep={(answers) => {
									if (nullSafeGet('0', answers)) {
										const troubleshootingAnswers = getUpdatedTsAnswersState(
											this.state,
											route,
											answers
										);
										this.setState({ troubleshootingAnswers });
									}
									route.args && this.proceedToNextStep(route.args);
								}}
								onCancel={this.cancelRequest}
								existingAnswer={existingAnswer}
							/>
						),
					},
				};
			}, {});
		};

		const defaultNavMenuSteps = [
			{
				title: this.state.userLocation.id ? 'userLocation' : 'locations',
				enabled: true,
			},
			...(this.state.areas && this.state.areas.length > 0
				? [
						{
							title: 'areasTopLevel',
							enabled: true,
						},
				  ]
				: []),
			...(this.state.area2Available
				? [
						{
							title: 'areasNextLevel',
							enabled: true,
						},
				  ]
				: []),
			...(this.state.area3Available
				? [
						{
							title: 'areasNextBranch',
							enabled: true,
						},
				  ]
				: []),
			{
				title: 'problemTypeTopLevel',
				enabled: this.isLocationFieldsSelected(),
			},
			...(this.state.problemTypeLevel2Available
				? [
						{
							title: 'problemTypeNextLevel',
							enabled: true,
						},
				  ]
				: []),
			...(this.state.problemTypeLevel3Available
				? [
						{
							title: 'problemTypeNextBranch',
							enabled: true,
						},
				  ]
				: []),
			...(this.state.assetsAvailable
				? [
						{
							title: 'asset',
							enabled: this.isLocationFieldsSelected() && this.isProblemTypeAndAssetSelected(),
						},
				  ]
				: []),
			...(this.state.hasSubAssets
				? [
						{
							title: WO_STEP_NAMES.SUB_ASSET,
							enabled: !!nullSafeGet('assetId', formData),
						},
				  ]
				: []),
			...(this.state.asset
				? [
						{
							title: 'assetCondition',
							enabled: true,
						},
				  ]
				: []),
			{
				title: 'title',
				enabled: this.isLocationFieldsSelected() && this.isProblemTypeAndAssetSelected(),
			},
			{
				title: 'photos',
				enabled:
					this.isLocationFieldsSelected() &&
					this.isProblemTypeAndAssetSelected() &&
					nullSafeGet('title', formData),
			},
			{
				title: 'priority',
				enabled:
					this.isLocationFieldsSelected() &&
					this.isProblemTypeAndAssetSelected() &&
					nullSafeGet('title', formData) &&
					imageCountMatched,
			},
			{
				title: 'supplier',
				enabled:
					this.isLocationFieldsSelected() &&
					this.isProblemTypeAndAssetSelected() &&
					nullSafeGet('title', formData) &&
					imageCountMatched &&
					this.isPrioritySelected(),
			},
			{
				title: 'nte',
				enabled:
					this.isLocationFieldsSelected() &&
					this.isProblemTypeAndAssetSelected() &&
					nullSafeGet('title', formData) &&
					imageCountMatched &&
					this.isPrioritySelected(),
			},
			...(nullSafeGetOrElse('isSharedContact', currentUser, false)
				? [
						{
							title: WO_STEP_NAMES.SUBMITTED_BY,
							enabled:
								this.isLocationFieldsSelected() &&
								this.isProblemTypeAndAssetSelected() &&
								nullSafeGet('title', formData) &&
								imageCountMatched &&
								this.isPrioritySelected(),
						},
				  ]
				: []),
			{
				title: 'completion',
				enabled:
					this.isLocationFieldsSelected() &&
					this.isProblemTypeAndAssetSelected() &&
					nullSafeGet('title', formData) &&
					imageCountMatched &&
					this.isPrioritySelected(),
			},
		];

		const getNavSteps = () => {
			const allNavSteps = mergeTroubleshootingRoutes(
				defaultNavMenuSteps,
				nullSafeGetOrElse('state.troubleshootingRoutes', this, []),
				(route) => defaultNavMenuSteps.map((_) => _.title).indexOf(route.previousStep),
				(route) => ({
					title: `troubleshooting-${route.id}`,
					enabled: true,
				})
			);

			return allNavSteps;
		};

		const defaultSteps = {
			[WO_STEP_NAMES.WALKTHROUGH_TASKS]: {
				id: 21,
				label: 'Walkthrough Tasks',
				component: (
					<WOTaskListStep
						getCurrentState={this.getCurrentState}
						formData={formData}
						goNextMethod={this.goNextAfterTaskList}
						setState={this.setCurrentState}
						form={form}
					/>
				),
			},
			userLocation: {
				id: 1,
				label: 'Location',
				component: (
					<WOUserLocation
						formData={formData}
						handleUserLocation={this.handleUserLocation}
						userLocation={this.state.userLocation}
						form={form}
						isProcessing={isProcessing}
					/>
				),
			},
			locations: {
				id: 2,
				label: 'Location',
				component: (
					<WOLocation
						formData={formData}
						goNextAfterBriefPause={this.goNextAfterBriefPause}
						setState={this.setCurrentState}
						form={form}
						resetFieldAFter={this.resetFieldAFter}
						isProcessing={isProcessing}
					/>
				),
			},
			areasTopLevel: {
				id: 3,
				label: 'Area',
				component: (
					<WOArea
						getCurrentState={this.getCurrentState}
						goBack={this.goBack}
						fieldName={AREA_LEVELS.TOP_LEVEL}
						form={form}
						goNext={this.goNext}
						setState={this.setCurrentState}
						changeId={this.changeId}
						isProcessing={isProcessing}
					/>
				),
			},
			areasNextLevel: {
				id: 4,
				label: 'Area - 2',
				component: (
					<WOArea
						getCurrentState={this.getCurrentState}
						goBack={this.goBack}
						fieldName={AREA_LEVELS.NEXT_LEVEL}
						form={form}
						goNext={this.goNext}
						setState={this.setCurrentState}
						changeId={this.changeId}
						isProcessing={isProcessing}
					/>
				),
			},
			areasNextBranch: {
				id: 5,
				label: 'Area - 3',
				component: (
					<WOArea
						getCurrentState={this.getCurrentState}
						goBack={this.goBack}
						fieldName={AREA_LEVELS.NEXT_BRANCH}
						form={form}
						goNext={this.goNext}
						setState={this.setCurrentState}
						changeId={this.changeId}
						isProcessing={isProcessing}
					/>
				),
			},
			problemTypeTopLevel: {
				id: 6,
				label: 'Problem Type',
				component: (
					<WOProblemType
						getCurrentState={this.getCurrentState}
						goBack={this.goBack}
						fieldName={PT_LEVELS.TOP_LEVEL}
						changeId={this.changeId}
						form={form}
						goNext={this.goNext}
						setState={this.setCurrentState}
						setNTE={this.setNTE}
						isProcessing={isProcessing}
					/>
				),
			},
			problemTypeNextLevel: {
				id: 7,
				label: 'Problem Type - 2',
				component: (
					<WOProblemType
						getCurrentState={this.getCurrentState}
						goBack={this.goBack}
						fieldName={PT_LEVELS.NEXT_LEVEL}
						changeId={this.changeId}
						form={form}
						goNext={this.goNext}
						setState={this.setCurrentState}
						setNTE={this.setNTE}
						isProcessing={isProcessing}
					/>
				),
			},
			problemTypeNextBranch: {
				id: 8,
				label: 'Problem Type - 3',
				component: (
					<WOProblemType
						getCurrentState={this.getCurrentState}
						goBack={this.goBack}
						fieldName={PT_LEVELS.NEXT_BRANCH}
						changeId={this.changeId}
						form={form}
						goNext={this.goNext}
						setState={this.setCurrentState}
						setNTE={this.setNTE}
						isProcessing={isProcessing}
					/>
				),
			},
			asset: {
				id: 9,
				label: 'Asset',
				component: (
					<div key={8} className="newWorkOrderWizardPage__section">
						<h3 className="newWorkOrderWizardPage__title" style={{ marginBottom: 16 }}>
							Is the problem affecting a particular piece of equipment?
						</h3>
						<div style={{ textAlign: 'center', marginBottom: 24 }}>
							{nullSafeGet('id', this.state.problemType) ? (
								<Button
									onClick={() => this.goNext([], 'title', WO_STEP_NAMES.ASSET)}
									type="link"
									disabled={isProcessing}
								>
									Skip
								</Button>
							) : null}
						</div>
						<Form.Item style={{ width: '100%' }}>
							{getFieldDecorator(`assetId`, {
								initialValue: nullSafeGet('assetId', formData),
							})(
								<OWAsyncRadio
									mode="default"
									fieldName="assetId"
									stateSlice={assets}
									onChange={this.handleAsset}
									onClick={this.handleAssetClick}
									targetCollectionName={'SERVICE_REQUEST_FORM_ASSETS_AUTOCOMPLETE'}
									keepFetchedOrder={true}
									fetchMultiple={(ids, targetCollectionName) =>
										fetchMultipleAssets(ids, targetCollectionName)
									}
									fetchData={(
										searchText,
										targetCollectionName,
										pagination = null,
										sorting = {
											sort_by: 'assetNumber',
											order: 'ascend',
										},
										filters = null,
										addToTargetCollection = false
									) =>
										fetchAssets(
											{
												search: searchText,
												topLevelOnly: 'true',
											},
											targetCollectionName,
											pagination,
											sorting,
											filters,
											addToTargetCollection
										)
									}
									renderRecord={(asset) => (
										<>
											<div className="flex flex-col">
												<Ellipsis
													tooltip={true}
													lines={3}
													fullWidthRecognition={true}
													style={{ fontSize: 14, wordBreak: 'normal' }}
												>
													{asset.name}
												</Ellipsis>
											</div>
											<AssetNumberDisplay
												asset={asset}
												style={{
													fontWeight: 400,
													fontSize: 14,
												}}
											/>
											{getWarrantyStatus(nullSafeGet('warranties.0', asset)) === 'Active' ? (
												<Ellipsis
													tooltip={false}
													lines={1}
													fullWidthRecognition={true}
													style={{
														marginTop: '4px',
														marginBottom: '4px',
														marginLeft: '-15px',
														fontWeight: 500,
														display: 'flex',
														position: 'absolute',
														bottom: 0,
														justifyContent: 'center',
														fontSize: 14,
													}}
												>
													Under Warranty
												</Ellipsis>
											) : null}
										</>
									)}
									additionalFilters={{
										...getAssetFilterForWOCreation(ROLE_TYPES.BUYER)(
											companyConfig,
											currentUser,
											this.state
										),
										brandId: nullSafeGet('location.brandId', this.state),
									}}
								/>
							)}
						</Form.Item>
						<div className="flex flex-row">
							<Button
								size="large"
								type="ghost"
								onClick={() => this.goBack()}
								loading={isProcessing}
								disabled={isProcessing}
							>
								Back
							</Button>
							{nullSafeGet('id', this.state.problemType) ? (
								<Button
									size="large"
									type="primary"
									className="ml-4"
									disabled={isProcessing}
									loading={isProcessing}
									onClick={() =>
										this.goNextAfterBriefPause(
											['assetId'],
											this.state.hasSubAssets ? WO_STEP_NAMES.SUB_ASSET : 'title',
											WO_STEP_NAMES.ASSET
										)
									}
								>
									Next step
								</Button>
							) : null}
						</div>
					</div>
				),
			},
			[WO_STEP_NAMES.SUB_ASSET]: {
				id: 9.5,
				label: 'Sub Assets',
				component: (
					<div className="newWorkOrderWizardPage__section">
						<h3 className="newWorkOrderWizardPage__title" style={{ marginBottom: 16 }}>
							Which sub assets are affected?
						</h3>
						<SubAssetSelectionStep
							parentAssetId={parseInt(nullSafeGet('assetId', formData), 10)}
							value={this.state.selectedSubAssetIds}
							onChange={(ids) => this.setState({ selectedSubAssetIds: ids })}
							fetchSubAssets={this.props.fetchSubAssets}
						/>
						<div className="flex flex-row" style={{ marginTop: 16 }}>
							<Button
								size="large"
								type="ghost"
								onClick={() => this.goBack()}
								loading={isProcessing}
								disabled={isProcessing}
							>
								Back
							</Button>
							<Button
								size="large"
								type="primary"
								className="ml-4"
								loading={isProcessing}
								disabled={isProcessing}
								onClick={() =>
									this.goNextAfterBriefPause(
										[],
										WO_STEP_NAMES.ASSET_CONDITION,
										WO_STEP_NAMES.SUB_ASSET
									)
								}
							>
								Next step
							</Button>
						</div>
					</div>
				),
			},
			assetCondition: {
				id: 10,
				label: 'Asset Status',
				component: (
					<div key={8} className="newWorkOrderWizardPage__section">
						<h3 className="newWorkOrderWizardPage__title" style={{ marginBottom: 16 }}>
							{`Is the asset functioning?`}
						</h3>
						<Form.Item style={{ width: '100%' }}>
							{getFieldDecorator(`isAssetDown`, {
								initialValue: nullSafeGetOrElse('isAssetDown', formData, ''),
							})(
								<OWRadio
									fieldName="assetId"
									onChange={this.handleAssetCondition}
									onClick={this.handleAssetCondition}
									renderRecord={(location) => location.name}
									records={{
										false: {
											id: 'false',
											name: 'Yes',
										},
										true: {
											id: 'true',
											name: 'No',
										},
									}}
									sorter={(records) => records.sort((a, b) => (a.id > b.id ? 1 : -1))}
								/>
							)}
						</Form.Item>
						<div className="flex flex-row">
							<Button
								size="large"
								type="ghost"
								onClick={() => this.goBack()}
								loading={isProcessing}
								disabled={isProcessing}
							>
								Back
							</Button>
						</div>
					</div>
				),
			},
			assetCheck: {
				id: 21,
				label: 'Asset Check',
				component: (
					<div key={8} className="newWorkOrderWizardPage__section">
						<h3 className="newWorkOrderWizardPage__title" style={{ marginBottom: 16 }}>
							{`Do you have the asset information with you?`}
						</h3>
						<Form.Item style={{ width: '100%' }}>
							{getFieldDecorator(`isAssetKnown`, {
								initialValue: nullSafeGetOrElse('isAssetKnown', formData, ''),
							})(
								<OWRadio
									fieldName="isAssetKnown"
									onChange={this.handleAssetCheck}
									onClick={this.handleAssetCheck}
									renderRecord={(location) => location.name}
									records={{
										true: {
											id: 'true',
											name: 'Yes',
										},
										false: {
											id: 'false',
											name: 'No',
										},
									}}
									sorter={(records) => records.sort((a, b) => (a.id < b.id ? 1 : -1))}
								/>
							)}
						</Form.Item>
						<div className="flex flex-row">
							<Button
								size="large"
								type="ghost"
								onClick={() => this.goBack()}
								loading={isProcessing}
								disabled={isProcessing}
							>
								Back
							</Button>
						</div>
					</div>
				),
			},
			title: {
				id: 11,
				label: 'Description',
				component: (
					<div key={9} className="newWorkOrderWizardPage__section">
						<h3 className="newWorkOrderWizardPage__title">
							In a few words, what's this request about?
						</h3>
						<Form.Item style={{ width: '100%', marginBottom: 40 }}>
							{getFieldDecorator(`title`, {
								rules: [{ required: true, message: 'Please describe the request.' }],
								initialValue: nullSafeGet('title', formData),
							})(
								<Input.TextArea
									autoSize
									showCount
									maxLength={120}
									style={{ width: '100%', marginBottom: 40 }}
									size="large"
								/>
							)}
						</Form.Item>
						<div className="flex flex-row">
							<Button
								size="large"
								type="ghost"
								onClick={() => this.goBack()}
								loading={isProcessing}
								disabled={isProcessing}
							>
								Back
							</Button>
							<Button
								size="large"
								type="primary"
								className="ml-4"
								disabled={isProcessing}
								loading={isProcessing}
								onClick={() => this.handleTitle()}
							>
								Next step
							</Button>
						</div>
					</div>
				),
			},
			duplicateCheck: {
				id: 22,
				label: 'Possible Duplicates',
				component: (
					<div key={11} className="newWorkOrderWizardPage__section">
						<h3 className="newWorkOrderWizardPage__title">
							We found potential duplicate requests. Do you still want to open a new request?
						</h3>
						<Table
							pagination={false}
							showHeader={false}
							dataSource={nullSafeGetOrElse('duplicateWorkOrders', this.state, [])}
							columns={duplicateWorkOrderColumns}
						/>
						<Form.Item style={{ width: '100%' }}>
							{getFieldDecorator(`isDuplicate`, {
								initialValue: nullSafeGet('isDuplicate', formData),
							})(
								<OWRadio
									fieldName="isDuplicate"
									onChange={this.handleDuplicate}
									onClick={this.handleDuplicate}
									renderRecord={(option) => option.name}
									records={{
										1: { id: 1, name: 'No, cancel this request' },
										2: { id: 2, name: 'Yes, this is a different issue' },
									}}
									sorter={(records) => records.sort((a, b) => (a.id > b.id ? 1 : -1))}
								/>
							)}
						</Form.Item>
						<Button
							size="large"
							type="ghost"
							onClick={() => this.goBack()}
							loading={isProcessing}
							disabled={isProcessing}
						>
							Back
						</Button>
					</div>
				),
			},
			photos: {
				id: 12,
				label: 'Photos',
				component: (
					<div key={10} className="newWorkOrderWizardPage__section">
						<h3 className="newWorkOrderWizardPage__title">Want to add some photos?</h3>
						<Form.Item
							style={{
								marginBottom: 20,
								width: '100%',
							}}
							className="text-center"
						>
							{getFieldDecorator(`images`, {
								valuePropName: 'fileList',
								getValueFromEvent: normFile,
								initialValue: this.state.allPhotos,
								rules: getImageCountErrorRules(minPhotosCount, imageCountErrorMessage),
							})(
								<OWUpload
									accept={imageWildcardUploadAccept}
									name="file"
									listType="picture-card"
									className="workorder-image-uploader"
									multiple={true}
									headers={uploadHeaders}
									onPreview={this.handlePreview}
									action={`${BACKEND_URI}/api/v1/buyer/file/upload`}
									beforeUpload={imageUploadValidation}
									onChange={this.handleImageUpdate}
								>
									<div style={{ display: 'inline' }}>
										<LegacyIcon type={this.state.uploadLoading ? 'loading' : 'plus'} />
										<div className="ant-upload-text">Upload</div>
									</div>
									<Modal visible={previewVisible} footer={null} onCancel={this.handleCancel}>
										<ResolvedImage
											url={previewImage || ''}
											style={{ width: '100%', objectFit: 'contain' }}
											preview={false}
										/>
									</Modal>
								</OWUpload>
							)}
						</Form.Item>
						<div className="flex flex-row">
							<Button
								size="large"
								type="ghost"
								onClick={() => this.goBack()}
								loading={isProcessing}
								disabled={isProcessing}
							>
								Back
							</Button>
							<Button
								size="large"
								type="primary"
								className="ml-4"
								loading={isImageUploading || isProcessing}
								disabled={isProcessing}
								onClick={() =>
									this.goNextAfterBriefPause(['images'], 'priority', WO_STEP_NAMES.PHOTOS)
								}
							>
								Next step
							</Button>
						</div>
					</div>
				),
			},
			priority: {
				id: 13,
				label: 'Priority',
				component: (
					<WOPriority
						state={this.state}
						goBack={this.goBack}
						form={form}
						goNext={this.goNext}
						setState={this.setCurrentState}
						goNextAfterBriefPause={this.goNextAfterBriefPause}
						isProcessing={isProcessing}
					/>
				),
			},
			supplier: {
				id: 14,
				label: 'Service Provider',
				component: (
					<div key={12} className="newWorkOrderWizardPage__section">
						<h3 className="newWorkOrderWizardPage__title">
							Who do you want to get it assigned to?
						</h3>
						<div style={{ textAlign: 'center', marginBottom: 24 }}>
							<Button
								onClick={() => {
									this.setState({ supplier: null, skipSupplier: true }, () => {
										this.handleSupplierChange();
									});
								}}
								type="link"
								disabled={isProcessing}
							>
								Skip
							</Button>
						</div>
						<Form.Item
							style={{
								marginBottom: 20,
								width: '100%',
							}}
						>
							{getFieldDecorator(`supplierFacilityId`, {
								initialValue: nullSafeGet('supplier.id', this.state),
							})(
								<OWAsyncRadio
									keepFetchedOrder={!showingAllSuppliers}
									mode="default"
									fieldName="supplierFacilityId"
									stateSlice={supplierFacilities}
									onChange={this.handleSupplierChange}
									onClick={this.handleSupplierChange}
									orderRecords={(records) => {
										const assetSupplierId = getActiveAssetWarrantySupplierId(this.state.asset);
										const buildingSupplierId = getActiveBuildingWarrantySupplierId(
											this.state.location,
											nullSafeGet('problemType.id', this.state)
										);
										let ordered = records;
										if (assetSupplierId) {
											ordered = moveObjectToBeginning(ordered, 'id', assetSupplierId);
										}
										if (buildingSupplierId) {
											ordered = moveObjectToBeginning(ordered, 'id', buildingSupplierId);
										}
										return ordered;
									}}
									targetCollectionName={
										'WORK_ORDER_FORM_SUPPLIER_FACILITIES_IN_PRIVATE_NETWORK_AUTOCOMPLETE'
									}
									fetchMultiple={(ids, targetCollectionName) =>
										fetchMultipleSupplierFacilities(ids, targetCollectionName)
									}
									fetchData={(
										searchText,
										targetCollectionName,
										pagination = null,
										sorting = null,
										filters = null,
										addToTargetCollection = false
									) =>
										new Promise((resolve, reject) =>
											fetchSupplierFacilitiesInPrivateNetwork(
												{ name: searchText },
												targetCollectionName,
												pagination,
												sorting,
												showingAllSuppliers ? {} : filters,
												addToTargetCollection
											).then((data) => {
												const assetSupplierId = getActiveAssetWarrantySupplierId(this.state.asset);
												const buildingSupplierId = getActiveBuildingWarrantySupplierId(
													this.state.location,
													nullSafeGet('problemType.id', this.state)
												);
												const missing = [assetSupplierId, buildingSupplierId].filter(
													(id) => id && !data.some((supplier) => supplier.id === id)
												);
												if (missing.length === 0) {
													resolve(data);
												} else {
													let promise = Promise.resolve(data);
													missing.forEach((id) => {
														promise = promise.then(() =>
															addWarrantySupplier(
																id,
																'WORK_ORDER_FORM_SUPPLIER_FACILITIES_IN_PRIVATE_NETWORK_AUTOCOMPLETE'
															)
														);
													});
													promise.then((finalData) => resolve(finalData));
												}
											})
										)
									}
									renderRecord={(supplierFacility, apiSuppliers, searchText) => {
										const buildingSupplierId = getActiveBuildingWarrantySupplierId(
											this.state.location,
											nullSafeGet('problemType.id', this.state)
										);
										const assetSupplierId = getActiveAssetWarrantySupplierId(this.state.asset);
										const isBuilding = buildingSupplierId === supplierFacility.id;
										const isAsset = assetSupplierId === supplierFacility.id;
										return (
											<div>
												<Ellipsis
													tooltip={true}
													length={32}
													fullWidthRecognition={true}
													style={{ wordBreak: 'normal' }}
												>
													{supplierFacility.name}
												</Ellipsis>
												{isBuilding || isAsset ? (
													<span className="mt-0 inline-block  text-sm text-gray-400">
														{isBuilding ? '(Building Warranty)' : null}
														{isBuilding && isAsset ? ' ' : null}
														{isAsset ? '(Warranty)' : null}
													</span>
												) : (
													<p className={'mb-0'}>
														{!showingAllSuppliers &&
															!(searchText && searchText.length) &&
															(apiSuppliers.find((item) => item.id === supplierFacility.id) ? (
																<span className="mt-0 inline-block  text-sm text-gray-400">
																	(Rank{' '}
																	{apiSuppliers.findIndex(
																		(item, index) => supplierFacility.id === item.id
																	) + 1}
																	)
																</span>
															) : null)}
													</p>
												)}
											</div>
										);
									}}
									additionalFilters={{
										problemTypeId: nullSafeGet('problemType.id', this.state),
										brandId: nullSafeGet('location.brandId', this.state),
										locationId: nullSafeGet('location.id', this.state),
									}}
								/>
							)}
						</Form.Item>
						<Row style={{ flexDirection: 'column' }} align="middle">
							<AccessPermissionChecker
								name={PERMISSION_NAMES.CAN_SHOW_ALL_SUPPLIERS_IN_WO_CREATION}
							>
								<Button
									size="large"
									type="ghost"
									icon={
										<Popover
											overlayStyle={{ zIndex: 1060 }}
											content={
												showingAllSuppliers
													? 'Click me to see only service providers which handle selected request type and location'
													: 'Click me to see all your network service providers'
											}
										>
											<InfoCircleOutlined />
										</Popover>
									}
									onClick={() => {
										new Promise((resolve, reject) =>
											fetchSupplierFacilitiesInPrivateNetwork(
												'',
												'WORK_ORDER_FORM_SUPPLIER_FACILITIES_IN_PRIVATE_NETWORK_AUTOCOMPLETE',
												{ current: 1, pageSize: 250 },
												{},
												showingAllSuppliers
													? {
															problemTypeId: nullSafeGet('problemType.id', this.state),
															locationId: nullSafeGet('location.id', this.state),
															brandId: nullSafeGet('location.brandId', this.state),
													  }
													: {},
												false
											).then((data) => {
												const assetSupplierId = getActiveAssetWarrantySupplierId(this.state.asset);
												const buildingSupplierId = getActiveBuildingWarrantySupplierId(
													this.state.location,
													nullSafeGet('problemType.id', this.state)
												);
												const missing = [assetSupplierId, buildingSupplierId].filter(
													(id) => id && !data.some((supplier) => supplier.id === id)
												);
												if (missing.length === 0) {
													resolve(data);
												} else {
													let promise = Promise.resolve(data);
													missing.forEach((id) => {
														promise = promise.then(() =>
															addWarrantySupplier(
																id,
																'WORK_ORDER_FORM_SUPPLIER_FACILITIES_IN_PRIVATE_NETWORK_AUTOCOMPLETE'
															)
														);
													});
													promise.then((finalData) => resolve(finalData));
												}
											})
										);
										this.setState({ showingAllSuppliers: !showingAllSuppliers });
									}}
									style={{ marginBottom: 16 }}
								>
									{showingAllSuppliers ? 'Hide' : 'Show All'}
								</Button>
							</AccessPermissionChecker>
							<div className="flex flex-row">
								<Button
									size="large"
									type="ghost"
									onClick={() => this.goBack()}
									loading={isProcessing}
									disabled={isProcessing}
								>
									Back
								</Button>
								<Button
									size="large"
									type="primary"
									className="ml-4"
									disabled={isProcessing}
									loading={isProcessing}
									onClick={() => {
										this.handleSupplierChange();
									}}
								>
									Next step
								</Button>
							</div>
						</Row>
					</div>
				),
			},
			nte: {
				id: 15,
				label: 'NTE',
				component: (
					<div key={13} className="newWorkOrderWizardPage__section">
						<h3 className="newWorkOrderWizardPage__title">
							Would you like to set a Not-to-Exceed amount?
						</h3>
						<div style={{ display: 'flex', flexDirection: 'row', gap: 24 }}>
							<Form.Item
								validateStatus={userApprovalInfo.status}
								help={
									userApprovalInfo.status ? (
										<div
											style={{ width: '800px' }}
											className={'absolute flex flex-row flex-nowrap'}
										>
											{`This NTE change requires a quote. Based on approval hierarchy, you can set NTE upto ${locationCurrency.format(
												userApprovalInfo.amount * currencyExchangeRateBuyerToLocation
											)}`}
										</div>
									) : (
										''
									)
								}
							>
								{getFieldDecorator(`nte`, {
									validateTrigger: 'onChange',
									rules: [
										{
											validator: (rule, value, callback) => {
												if (
													userApprovalInfo.amount &&
													parseFloat(value) / currencyExchangeRateBuyerToLocation >
														parseFloat(userApprovalInfo.amount) &&
													parseFloat(value) / currencyExchangeRateBuyerToLocation !== formData.nte
												) {
													this.setState({
														userApprovalInfo: {
															...userApprovalInfo,
															status: isAdmin ? 'warning' : 'error',
														},
													});
													callback(isAdmin ? undefined : '');
												} else {
													this.setState({
														userApprovalInfo: {
															...userApprovalInfo,
															status: null,
														},
													});
													callback();
												}
											},
										},
									],
									initialValue: nullSafeGet(`nte`, formData),
								})(
									<InputNumber
										placeholder="Enter a value.."
										style={{ width: '200px' }}
										size="large"
										addonAfter={locationCurrency.id}
										onChange={(value) => this.setNTE(value)}
									/>
								)}
							</Form.Item>
							{nullSafeGet('supplier.currencyId', this.state) && !isSameCurrency ? (
								<div style={{ display: 'flex', flexDirection: 'row' }}>
									<i
										className="icons8-font icons8-data-transfer flex"
										style={{ fontSize: 24, marginTop: 16, marginRight: 26 }}
									/>
									<InputNumber
										style={{ width: '200px' }}
										size="large"
										disabled={true}
										addonAfter={workOrderCurrency.id}
										value={(this.state.nte * currencyExchangeRateLocationToSupplier).toFixed(2)}
									/>
								</div>
							) : null}
						</div>
						<div className="flex flex-row pt-4">
							<Button
								size="large"
								type="ghost"
								onClick={() => this.goBack()}
								loading={isProcessing}
								disabled={isProcessing}
							>
								Back
							</Button>
							<Button
								size="large"
								type="primary"
								className="ml-4"
								disabled={isProcessing}
								loading={isProcessing}
								onClick={() => {
									this.handleNTESubmit();
									this.checkForSharedContactAndMoveToNextStep(['nte'], WO_STEP_NAMES.NTE);
								}}
							>
								Next step
							</Button>
						</div>
					</div>
				),
			},
			submittedBy: {
				id: 16,
				label: 'Submitted By',
				component: (
					<div key={15} className="newWorkOrderWizardPage__section">
						<h3 className="newWorkOrderWizardPage__title">Can you provide your name?</h3>
						<Form.Item style={{ width: '60%', marginBottom: 40 }}>
							{getFieldDecorator(`submittedByName`, {
								rules: [
									{
										required: this.state.submittedByNameIsRequired,
										message: 'Please provide your full name.',
									},
								],
								initialValue: nullSafeGet('submittedByName', formData),
							})(<Input size="large" />)}
						</Form.Item>
						<div className="flex flex-row">
							<Button
								size="large"
								type="ghost"
								onClick={() => this.goBack()}
								loading={isProcessing}
								disabled={isProcessing}
							>
								Back
							</Button>
							<Button
								size="large"
								type="primary"
								className="ml-4"
								disabled={isProcessing}
								loading={isProcessing}
								onClick={() =>
									this.goNextAfterBriefPause(
										['submittedByName'],
										WO_STEP_NAMES.COMPLETION,
										WO_STEP_NAMES.SUBMITTED_BY
									)
								}
							>
								Next step
							</Button>
						</div>
					</div>
				),
			},
			completion: {
				id: 17,
				label: 'Summary',
				component: (
					<div key={14} className="newWorkOrderWizardPage__section" style={{ width: '100%' }}>
						<h3 className="newWorkOrderWizardPage__title">Summary</h3>
						<div style={{ marginBottom: 24, maxWidth: '60%' }}>
							<WorkOrderSummary workOrderDetails={workOrderDetails} photoStrings={photoStrings} />
						</div>
						<div className="flex flex-row">
							<Button
								size="large"
								type="ghost"
								onClick={() => this.goBack()}
								loading={isProcessing}
								disabled={isProcessing}
							>
								Back
							</Button>
							<Button
								className="ml-4"
								onClick={
									this.state.onlyForPreview
										? onCancelRequest(this.props, this.state)
										: this.handleSubmit
								}
								type="primary"
								size="large"
								loading={isProcessing}
								disabled={isProcessing}
							>
								{this.state.onlyForPreview ? 'Exit Preview' : 'Create Work Order'}
							</Button>
						</div>
					</div>
				),
			},
		};

		const getSteps = () => {
			const allStepKeys = mergeTroubleshootingRoutes(
				Object.keys(defaultSteps),
				nullSafeGetOrElse('state.troubleshootingRoutes', this, []),
				(route) => Object.keys(defaultSteps).indexOf(route.previousStep),
				(route) => `troubleshooting-${route.id}`
			);

			const troubleshootingSteps = getTroubleshootingSteps();

			const allSteps = allStepKeys.reduce((steps, key) => {
				return {
					...steps,
					[key]: key.startsWith('troubleshooting') ? troubleshootingSteps[key] : defaultSteps[key],
				};
			}, {});

			return allSteps;
		};

		const allNavSteps = getNavSteps();
		const currentStepKey = location.pathname.split('/')[location.pathname.split('/').length - 1];
		const currentStepIndex = allNavSteps.map((_) => _.title).indexOf(currentStepKey);
		const currentCompletionPercentage = ((currentStepIndex * 1.0) / allNavSteps.length) * 100;

		return (
			<div className="newWorkOrderWizardPage">
				<Drawer
					width={240}
					title="Overview"
					bodyStyle={{ padding: '16px 0' }}
					placement="left"
					closable={true}
					onClose={this.handleNavMenuClose}
					visible={this.state.navMenuVisible}
				>
					<Menu
						onClick={this.handleNavMenuClick}
						style={{ width: 240 }}
						defaultSelectedKeys={[currentStepKey]}
						mode="inline"
					>
						{allNavSteps.map((k) => {
							const step = getSteps()[k.title];
							return (
								<Menu.Item disabled={!k.enabled || isProcessing} key={k.title}>
									{step.label}
								</Menu.Item>
							);
						})}
					</Menu>
				</Drawer>
				<BuyerLocationUpdateForm
					wrappedComponentRef={this.saveFormRef('locationUpdateForm')}
					visible={this.state.locationUpdateVisible}
					formData={this.state.userContact}
					onCancel={this.handleBuyerLocationUpdateCancel}
					onSubmit={this.handleBuyerLocationUpdateSubmit}
					submitting={this.state.updatingLocation}
				/>
				<div
					style={{
						position: 'absolute',
						display: 'flex',
						alignItems: 'center',
						zIndex: 3,
						right: 16,
						top: 8,
					}}
				>
					<Button type="link" onClick={this.cancelRequest}>
						Cancel Request
					</Button>
				</div>
				<div className="newWorkOrderWizardPage__inner">
					{Object.keys(getSteps()).map((k) => {
						const step = getSteps()[k];
						return (
							<Route
								key={step.id}
								path={`/buyer/workOrders/newWorkOrder/${k}`}
								render={() => step.component}
								exact={true}
							/>
						);
					})}
				</div>
				<div
					style={{
						position: 'absolute',
						display: 'flex',
						alignItems: 'center',
						zIndex: 3,
						left: 0,
						right: 0,
						bottom: 0,
						backgroundColor: 'white',
						border: '1px solid #f5f5f5',
						width: '100%',
					}}
				>
					<Button
						style={{ display: 'inline-block', margin: '8px 16px 8px 8px' }}
						size="large"
						icon={<MenuOutlined />}
						onClick={this.handleNavMenuOpen}
					>
						Overview
					</Button>
					<Progress
						style={{ margin: '8px 16px 8px 8px' }}
						strokeLinecap="square"
						strokeColor="#6027b0"
						percent={currentCompletionPercentage}
						showInfo={false}
					/>
				</div>
				{this.state.selfManagedSupplierEmailModalVisible && (
					<SelfManagedSupplierEmailPromptModal
						visible
						showContext
						supplierFacility={this.state.supplier}
						onSkip={this.handleSelfManagedSupplierEmailSkipped}
						onInvited={this.handleSelfManagedSupplierEmailInvited}
					/>
				)}
			</div>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	redirectForwardUrl: ownProps.redirectForwardUrl,
	formData: state.work_orders.formData,
	currentUser: state.session.currentUser,
	companyConfig: state.company_config.detail,
	spendCategories: state.spend_categories,
	problemTypes: state.problem_types,
	locations: state.locations,
	creating: state.work_orders.creating,
	workOrderPriorities: state.work_order_priorities,
	assets: state.assets,
	supplierFacilities: state.supplier_facilities,
	areas: state.areas,
	location: ownProps.location,
});

const mapDispatchToProps = (dispatch) => ({
	saveFormData: (formData) => dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.saveFormData(formData)),
	clearFormData: () => dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.clearFormData()),
	fetchArea: (id) => dispatch(areasRestCrudThunksForBuyer.readOne(id)),
	fetchAreas: (params, targetCollectionName, pagination, sorting, filters, addToTargetCollection) =>
		dispatch(
			areasRestCrudThunksForBuyer.read(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchMultipleAreas: (ids, targetCollectionName) =>
		dispatch(areasRestCrudThunksForBuyer.readMultiple(ids, targetCollectionName)),
	fetchAreasTopLevel: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			areasTopLevelForBuyer(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchBuyer: (id) => dispatch(buyersRestCrudThunksForBuyer.readOne(id)),
	fetchLocation: (id) => dispatch(locationsRestCrudThunksForBuyer.readOne(id)),
	fetchLocationsLite: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			locationsRestCrudThunksForBuyer.readLite(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchAsset: (id) => dispatch(assetsRestCrudThunksForBuyer.readOne(id)),
	fetchSubAssets: (parentId) =>
		dispatch(
			assetsRestReadThunk(
				ROLE_TYPES.BUYER,
				{ parentIds: parentId },
				SUB_ASSETS_TARGET_COLLECTION,
				{ current: 1, pageSize: 1000 },
				{ sort_by: 'name', order: 'ascend' }
			)
		),
	fetchAssets: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			assetsRestReadThunk(
				ROLE_TYPES.BUYER,
				{ ...params, view: 'workOrderCreation' },
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchMultipleAssets: (ids, targetCollectionName) =>
		dispatch(assetsRestReadThunk(ROLE_TYPES.BUYER, { ids }, targetCollectionName)),
	fetchSpendCategories: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			spendCategoriesRestCrudThunksForBuyer.read(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchProblemType: (id) => dispatch(problemTypesRestCrudThunksForBuyer.readOne(id)),
	fetchSupplierFacility: (id) => dispatch(supplierFacilitiesRestCrudThunksForBuyer.readOne(id)),
	fetchSupplierRelationship: (params) => dispatch(supplierPrivateNetworksV2ForBuyer(params)),
	fetchSupplierFacilitiesInPrivateNetwork: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			fetchSupplierFacilitiesInPrivateNetworkForBuyer(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection
			)
		),
	fetchMultipleSupplierFacilities: (ids, targetCollectionName) =>
		dispatch(supplierFacilitiesRestCrudThunksForBuyer.readMultiple(ids, targetCollectionName)),
	fetchWorkOrderAttributes: (params) =>
		dispatch(workOrderAttributesRestCrudThunksForBuyer.read(params)),
	submitWorkOrderForm: (workOrder) => dispatch(workOrdersRestCrudThunksForBuyer.create(workOrder)),
	addWarrantySupplier: (supplierId, targetCollectionName) =>
		dispatch(addWarrantySupplierToStoreState(supplierId, targetCollectionName)),
	roleUpdateUser: (entity) => dispatch(buyerRoleUpdateUser(entity)),
	fetchExchangeRate: (c1, c2, userType) => dispatch(getExchangeRate(c1, c2)(userType)),
	fetchTroubleshooting: (params) => dispatch(troubleshootingRestCrudThunksForBuyer.read(params)),
	getApprovalHierarchy: (params) =>
		dispatch(getProposalApprovalHierarchiesByAttributes('buyer', params)),
	fetchWorkOrders: (
		params,
		targetCollectionName,
		pagination,
		sorting,
		filters,
		addToTargetCollection
	) =>
		dispatch(
			workOrdersRestCrudThunksForBuyer.searchAndHydrate(
				params,
				targetCollectionName,
				pagination,
				sorting,
				filters,
				addToTargetCollection,
				workOrderSearchAndAPIAdaptor
			)
		),
	createTroubleshootingAnswersBulk: (entities) =>
		dispatch(troubleshootingAnswersRestCrudThunksForBuyer.createBulk(entities)),
	getWalkthrough: (id) => dispatch(walkthroughsRestCrudThunksForBuyer.readOne(id)),
	linkWorkOrders: (baseWorkOrder, workOrderIds, linkWithPreExistingWorkOrders) =>
		dispatch(linkWorkOrderForBuyer(baseWorkOrder, workOrderIds, linkWithPreExistingWorkOrders)),
	deleteWorkOrderFromRedux: (entity) =>
		dispatch(WORK_ORDERS_CRUD_ACTION_CREATORS.deleteSuccess(entity)),
	fetchWorkOrderPriority: (id) => dispatch(workOrderPrioritiesRestCrudThunksForBuyer.readOne(id)),
	findDuplicateWorkOrders: (params) => findDuplicateWorkOrdersForBuyer(params),
});

export default withRouter<any, any>(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(
		Form.create<NewWorkOrderWizardProps>({
			onValuesChange: (props, changedFields) => {
				props.saveFormData(changedFields);
			},
		})(NewWorkOrderWizardPage)
	)
);
